<template>
  <div>
    <Card>
      <Form ref="booking" :model="booking" :label-width="80">
        <Form-item :label="$t('pages_bookings_index_229')" prop="category">
          <Select
            v-model="booking.fresh_supplier_id"
            :placeholder="$t('pages_bookings_index_229')"
            clearable
            :label="booking.fresh_supplier_name"
          >
            <Option
              v-for="(cat, index) in suppliers"
              :value="cat.id"
              :key="index"
              >{{ cat.name }}</Option
            >
          </Select>
        </Form-item>
        <Form-item
            v-for="(item, index) in booking.selected_products"
            :key="index"
            :label="$t('pages_bookings_new_232') + (index + 1)"
            :prop="'selected_products.' + index + '.name'">
            <Row>
              <Col span="18">
                <Form>
                  <Form-item :label="$t('pages_ai_image_158')">
                    <Select
                      v-model="item.fresh_product_id"
                      style="width: 220px;"
                      :placeholder="$t('pages_bookings_new_233')"
                    >
                      <Option
                        v-for="(cat, index) in products_all"
                        :value="cat.id"
                        :key="index"
                        >{{ cat.name }}</Option
                      >
                    </Select>
                  </Form-item>
                  <Form-item :label="$t('pages_bookings_detail_224')" prop="note">
                    <Input type="text" v-model="item.jinghuojia" :placeholder="$t('pages_bookings_new_234')" style="width: 220px;"/>
                  </Form-item>
                  <Form-item :label="$t('pages_bookings_detail_223')" prop="note">
                    <Input type="text" v-model="item.stocks" :placeholder="$t('pages_bookings_new_234')" style="width: 220px;"/>
                  </Form-item>
                </Form>
              </Col>
              <Col span="4" offset="1">
                <Button @click="handleRemove(index)">{{$t('libs_table_render_70')}}</Button>
              </Col>
            </Row>
        </Form-item>
        <Form-item>
          <Row>
            <Col span="10">
              <Button type="success" long @click="handleAdd" icon="plus-round">{{$t('pages_banners_index_178')}}</Button>
            </Col>
          </Row>
        </Form-item>
        <Form-item :label="$t('pages_bookings_index_230')" prop="note">
          <Input type="text" v-model="booking.note" />
        </Form-item>
        <Form-item>
          <Button type="primary" long @click="handleSubmit('booking')">{{$t('pages_bookings_new_235')}}</Button>
        </Form-item>
      </Form>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      booking: {
        fresh_supplier_id: null,
        selected_products: [
          {
            fresh_product_id: null,
            stocks: '',
            jinghuojia: ''
          }
        ]
      }
    }
  },
  created () {
    this.supplier_index()
    // this.product_index({ is_binding: true })
    this.product_index()
  },
  computed: {
    ...mapGetters('supplier', ['suppliers']),
    ...mapGetters('product', ['products_all'])
  },
  methods: {
    ...mapActions('booking', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapActions('supplier', { supplier_index: 'index' }),
    ...mapActions('product', { product_index: 'index_all' }),
    handleAdd () {
      this.booking.selected_products.push({ fresh_product_id: null, stocks: '', jinghuojia: '' })
    },
    handleRemove (index) {
      this.booking.selected_products.splice(index, 1)
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    async handleSubmit () {
      await this.create(this.booking)

      this.$router.replace('/cg')
    }
  }
}
</script>
